<template>


	<div class="sort">
		<a :class="{ 'active': currentSort === item.sort }" v-for="(item, index) in sortList" @click="doSort( item.sort )" style="cursor: pointer;">{{ item.name }}</a>
	</div>

</template>

<script>
export default {
	name: "boardSorter",
	data() {

		let currentSort = this.webUtils.getParameter("sort");
		if ( this.stringUtils.isEmpty(currentSort) ) {
			currentSort = "createDate,DESC";
		}

		const sortList = [];
		sortList.push({
			sort: "createDate,DESC",
			name: "최신순"
		});
		sortList.push({
			sort: "title,ASC",
			name: "이름순"
		});
		sortList.push({
			sort: "views,DESC",
			name: "조회순"
		});

		return {
			currentSort,
			sortList,
		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		doSort ( _sort ) {
			this.currentSort = _sort;
			this.$emit("doSort", _sort);
		}

	}
}
</script>

<style scoped>

</style>